import { forwardRef, useCallback } from 'react';
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

const ErrorToast = forwardRef<HTMLDivElement, CustomContentProps>(({ id, ...props }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  return (
    <SnackbarContent ref={ref}>
      <Card className="w-400 bg-red-500">
        <div className="flex justify-between items-center py-8 px-16">
          <FuseSvgIcon className="mr-12 text-white">material-solid:cancel</FuseSvgIcon>

          <Typography variant="body2" className="text-15 font-700 text-white">
            {props.message}
          </Typography>

          <IconButton size="small" className="text-white font-700" onClick={handleDismiss}>
            <FuseSvgIcon className="text-white">material-solid:close</FuseSvgIcon>
          </IconButton>
        </div>
      </Card>
    </SnackbarContent>
  );
});

ErrorToast.displayName = 'ErrorToast';

export default ErrorToast;
